var BaseStorage = /** @class */ (function () {
    function BaseStorage() {
    }
    BaseStorage.verify = function (strategy) {
        if (strategy instanceof BaseStorage) {
            return strategy;
        }
        else {
            throw new Error('This class must extend BaseStorage!');
        }
    };
    BaseStorage.prototype.extendScope = function (scope) {
        return scope;
    };
    return BaseStorage;
}());
export { BaseStorage };
//# sourceMappingURL=base-storage.js.map